import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

/**
 * 確認ダイアログ表示関数
 */
const confirm = ({ body }) => {
  const wrapper = document.body.appendChild(document.createElement('div'));
  const cleanup = () => {
    ReactDOM.unmountComponentAtNode(wrapper);
    return setTimeout(() => wrapper.remove());
  };
  const promise = new Promise((resolve, reject) => {
    try {
      ReactDOM.render(
        <ConfirmationModal
          cleanup={cleanup}
          resolve={resolve}
          body={body}
        />,
        wrapper
      );
    } catch (e) {
      cleanup();
      reject(e);
      throw e;
    }
  });
  return promise;
};

/**
 * 確認ダイアログコンポーネント
 */
const ConfirmationModal  = ({body, resolve, cleanup}) => {
  const [show, setShow ] = React.useState(true);

  /**
   * キャンセルボタンを押下したときに呼び出される関数
   */
  const cancel = () => {
    setShow(false);
    resolve(false);
    cleanup();
  };

  /**
   * OKボタンを押下したときに呼び出される関数
   */
  const confirm = () => {
    setShow(false);
    resolve(true);
    cleanup();
  };

  return (
    <div className="static-modal">
      <Modal show={show} onHide={cancel} backdrop>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button
            className='btn btn-light'
            onClick={cancel}>
              Cancel
          </Button>
          <Button
            className='button-l'
            bsstyle='primary'
            onClick={confirm}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
ConfirmationModal.propTypes = {
  body: PropTypes.string,
  resolve: PropTypes.func,
  cleanup: PropTypes.func,
};
export default confirm;